import { render, staticRenderFns } from "./form-text.vue?vue&type=template&id=1d7b7035&scoped=true&"
import script from "./form-text.vue?vue&type=script&lang=js&"
export * from "./form-text.vue?vue&type=script&lang=js&"
import style0 from "./form-text.vue?vue&type=style&index=0&id=1d7b7035&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7b7035",
  null
  
)

export default component.exports